"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "DropdownLink", {
    enumerable: true,
    get: function() {
        return DropdownLink;
    }
});
const _react = /*#__PURE__*/ _interop_require_wildcard(require("react"));
const _NavLink = require("../../NavLink/NavLink");
const _Dropdown = require("../Dropdown");
function _getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return (_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function _interop_require_wildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) {
        return obj;
    }
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") {
        return {
            default: obj
        };
    }
    var cache = _getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) {
        return cache.get(obj);
    }
    var newObj = {
        __proto__: null
    };
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj){
        if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
            var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
            if (desc && (desc.get || desc.set)) {
                Object.defineProperty(newObj, key, desc);
            } else {
                newObj[key] = obj[key];
            }
        }
    }
    newObj.default = obj;
    if (cache) {
        cache.set(obj, newObj);
    }
    return newObj;
}
const DropdownLink = /*#__PURE__*/ (0, _react.forwardRef)((param, ref)=>{
    let { children, ...props } = param;
    const { autoClose } = (0, _react.useContext)(_Dropdown.DropdownContext);
    return /*#__PURE__*/ _react.default.createElement(_NavLink.NavLink, {
        ...props,
        ref: ref,
        onClick: (e)=>{
            var _props_onClick;
            autoClose();
            (_props_onClick = props.onClick) === null || _props_onClick === void 0 ? void 0 : _props_onClick.call(props, e);
        }
    }, children);
});
DropdownLink.displayName = "DropdownLink";

//# sourceMappingURL=DropdownLink.js.map